export default "__VITE_ASSET__DZn58sY3__"